'use client';

import { Box } from '@skin-seoul/design-system';
import LucideIcon from './LucideIcon';
interface CustomAccordionIndicatorProps {
  isOpen?: boolean;
  value?: string;
  accordionValue?: string[];
}

/**
 * Custom accordion indicator that switches between Plus and Minus icons
 * Used for expandable filter sections and other accordion interfaces
 */
const CustomAccordionIndicator = ({
  isOpen,
  value,
  accordionValue
}: CustomAccordionIndicatorProps) => {
  const isAccordionOpen = isOpen ?? (value && accordionValue ? accordionValue.includes(value) : undefined);
  return <Box position="relative" width="16px" height="16px" data-sentry-element="Box" data-sentry-component="CustomAccordionIndicator" data-sentry-source-file="CustomAccordionIndicator.tsx">
      <LucideIcon name={isAccordionOpen ? 'CircleMinus' : 'CirclePlus'} width="16px" height="16px" color="neutral.500" data-sentry-element="LucideIcon" data-sentry-source-file="CustomAccordionIndicator.tsx" />
    </Box>;
};
export default CustomAccordionIndicator;